import { GetServiceConfigurationRequestParam, TotalCategoryParams } from '@tmap-web-lib/remote-api-client/frontman'

export const KEYS = {
  // 약관
  TERMS_GROUP_WITH_AGREEMENT: (termsGroupCode?: string) => ['termsGroupWithAgreement', termsGroupCode],

  // 공통
  USER_INFO: () => ['userInfo'],
  EVENT_BANNER_LIST:() => ['eventBannerList'],
  EVENT_JOIN_STATUS: (eventName: string) => ['eventJoinStatus', eventName],
  RED_DOT_LIST: (groupName?: string) => ['redDotList', groupName],
  OTP_CODE: () => ['otpCode'],

  // 주행 정보
  DRIVING_SCORE_REPORTS: () => ['drivingScoreReports'],
  DRIVING_SCORE_MONTHLY_REPORTS: () => ['drivingScoreMonthlyReports'],
  SIMPLE_SAFE_DRIVING_INFO: () => ['simpleSafeDrivingInfo'],
  TRIP_SAFE_DRIVING_INFO: (createdAt?: string, lastMonth?: number, nextToken?: string) => ['tripSafeDrivingInfo', createdAt, lastMonth, nextToken],
  MONTHLY_TRIP_SCORE_INFO: () => ['monthlyTripScoreInfo'],
  TRIP_DRIVING_DETAIL_INFO: () => ['tripDrivingDetailInfo'],
  SAME_OD_ROUTE_ID: () => ['sameOdRouteId'],
  LATEST_VIOLATIONS: () => ['latestViolations'],

  // 차량
  CAR_PROFILE_LIST: () => ['carProfileList'],
  CAR_PROFILE: () => ['carProfile'],
  CAR_OPTION_CODE_LIST: () => ['carOptionCodeList'],
  UNPAID_TOLLS: () => ['unpaidTolls'], // 내차관리 > 미납통행건수 조회
  UNPAID_TOLLS_LIST:() => ['unpaidTollsList'], // 미납통행료 내역
  CAR_RECALL_INFOS: () => ['carRecallInfos'],
  CAR_MAINTENANCE: (carProfileId?: string) => ['carMaintenance', carProfileId],

  // 운전분석
  USER_RANKS: () => ['userRanks'],
  MODEL_AVERAGE_SCORES: () => ['modelAverageScores'],
  USER_EXPECTED_RANKS: (score?: number) => ['userExpectedRanks', score],

  // 혜택
  BENEFIT_CATEGORIES: () => ['benefitCategories'],
  BENEFIT_LIST: () => ['benefitList'],
  INSURANCE_DETAIL: () => ['insuranceDetail'],
  INSURANCE_DISCOUNT: () => ['insuranceDiscount'],

  // 개인화 메시지
  USER_MESSAGES: () => ['userMessages'],

  // 컨텐츠
  SCORE_CONTENTS_LIST: () => ['scoreContentsList'],
  SCORE_CONTENTS_DETAIL: () => ['scoreContentsDetail'],
  BOARD_DETAIL: (boardKey: string) => ['boardDetail', boardKey],

  // 광고
  BANNER_TRACKING_LIST: (vimpressionId: string) => ['bannerList', vimpressionId],
  BANNER_LIST: (inventoryCode?: string) => ['bannerList', inventoryCode],

  // POI
  FAVORITE_LIST: () => ['favoriteList'],

  // 포인트
  POINTS_CHECK_EARN_TODAY: () => ['pointsCheckEarnToday'],

  // 라이나 간편보험
  LINA_INSURANCES_PRODUCTS: () => ['linaInsurancesProducts'],
  LINA_INSURANCES_USERS_ELIGIBILITY: () => ['linaInsurancesUsersEligibility'],
  LINA_INSURANCES_PRODUCT_STATUS: () => ['LinaInsuranceProductStatus'],
  LINA_INSURANCES_PRODUCT_REPORT_LIST: () => ['LinaInsuranceProductReportList'],
  LINA_INSURANCES_PRODUCT_REPORT_DETAIL: () => ['LinaInsuranceProductReportDetail'],
  LINA_INSURANCES_PROMOTIONS: () => ['LinaInsurancePromotions'],

  // 퀵메뉴
  QUICK_MENU_LIST: () => ['quickMenuList'],

  // 추천 메시지

  // 자주 방문한 카테고리/장소
  VISITED_CATEGORIES: (yearMonth: string) => ['VisitedCategories', yearMonth],
  VISITED_PLACES: (categoryCode: string, yearMonth: string, offset: number) => ['VisitedPlaces', categoryCode, yearMonth, offset],

  // 카테고리 정보 조회(장소 추천)
  CATEGORY_RECOMMENDED_PLACES: (params: TotalCategoryParams) => ['findCategoryPlaces', params],

  // 서비스 설정
  SERVICE_CONFIGURATION: (params: GetServiceConfigurationRequestParam) => ['serviceConfiguration', params],

  // TOS 타겟팅
  TOS_TARGET: () => ['tosTarget'],

  // 보험홈 설정 (CDN fallback)
  INSURANCE_HOME_CONFIG: () => ['insuranceHomeConfig'],

  // 광고 리워드 사용자
  ADS_REWARD_USER: () => ['adsRewardUser'],

  // 스마트 배너
  SMART_BANNER_SUMMARY: () => ['smartBannerSummary'],

  // 리워드쇼핑 (쿠팡)
  PARTNERS_COUPANG_SEARCH: () => ['partnersCoupangSearch'],
  BIZ_AUTH_REWARD_TOKEN: () => ['bizAuthRewardToken'],

  // 만보기
  STEP_COUNTER_DASHBOARD: (days?: number) => ['stepCounterDashboard', days],
  DRIVING_DASHBOARD: () => ['drivingDashboard'],
  DEVICE_CLAIM_STATUS: () => ['deviceClaimStatus'],

  // 커뮤니티 (오너톡)
  COMMUNITY_FEED: () => ['communityFeed'],
}
